import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

interface CarPriceHistory {
    id: number;
    dateDay: string;
    tagId: number;
    tagName: string | null;
    tagSlug: string | null;
    price_average: number | null;
    price_min: number | null;
    price_max: number | null;
    price_std: number | null;
    numberOfItems: number | null;
}

export class car_price_report_template extends vnTemplate{

    protected dateFilter: filterDate_template;
    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected getTemplateHtml(): string{

        return `
            <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div>
                            ${ this.dateFilter.getHtmlBuild() }
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-dates"></div>
                </div>
            </div>

            <div class="list-header w-justify">
                <div class="w-left"></div>
                <div class="w-center">
                    <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                        <div class="w-search-feild icon i-search2">
                            <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                            <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                            <input data-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                            <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                        </div>
                    </div>
                </div>
                <div class="w-right">
                    <button
                        style="margin: 10px"
                        data-bind="click : onClickExportToCSV , css: { 'is-disable': exportInProgress }, text : exportTextBox"
                        class="btn secondary icon i-export" type="button">
                    </button>
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${ this.resultInfos.getHtmlBuild() }
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateDay') }, css: { 'list-sort-desc': orderByAndDirection()=='dateDay_DESC', 'list-sort-asc': orderByAndDirection()=='dateDay_ASC' }">Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tagId') }, css: { 'list-sort-desc': orderByAndDirection()=='tagId_DESC', 'list-sort-asc': orderByAndDirection()=='tagId_ASC' }">Tag ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tagName') }, css: { 'list-sort-desc': orderByAndDirection()=='tagName_DESC', 'list-sort-asc': orderByAndDirection()=='tagName_ASC' }">Tag</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tagSlug') }, css: { 'list-sort-desc': orderByAndDirection()=='tagSlug_DESC', 'list-sort-asc': orderByAndDirection()=='tagSlug_ASC' }">Slug</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'price_average') }, css: { 'list-sort-desc': orderByAndDirection()=='price_average_DESC', 'list-sort-asc': orderByAndDirection()=='price_average_ASC' }">Avg Price</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'price_min') }, css: { 'list-sort-desc': orderByAndDirection()=='price_min_DESC', 'list-sort-asc': orderByAndDirection()=='price_min_ASC' }">Min Price</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'price_max') }, css: { 'list-sort-desc': orderByAndDirection()=='price_max_DESC', 'list-sort-asc': orderByAndDirection()=='price_max_ASC' }">Max Price</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'price_std') }, css: { 'list-sort-desc': orderByAndDirection()=='price_std_DESC', 'list-sort-asc': orderByAndDirection()=='price_std_ASC' }">Std Dev</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'numberOfItems') }, css: { 'list-sort-desc': orderByAndDirection()=='numberOfItems_DESC', 'list-sort-asc': orderByAndDirection()=='numberOfItems_ASC' }"># Items</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: priceHistory">
                        <tr class="cursor">
                            <td><span data-bind="text: dateDay"></span></td>
                            <td><span data-bind="text: tagId"></span></td>
                            <td><span data-bind="text: tagName || ''"></span></td>
                            <td><span data-bind="text: tagSlug || ''"></span></td>
                            <td><span data-bind="text: price_average == null ? '-' : Number(price_average).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td><span data-bind="text: price_min == null ? '-' : Number(price_min).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td><span data-bind="text: price_max == null ? '-' : Number(price_max).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td><span data-bind="text: price_std == null ? '-' : Number(price_std).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td><span data-bind="text: numberOfItems == null ? '-' : Number(numberOfItems).toLocaleString('en-US')"></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        `;
    }

    protected initPartial(): void{

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.setDefaultDateRange();

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{
        return "car-price-report-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return {
            orderBy: ko.observable("dateDay"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateDay_DESC"),
            priceHistory: ko.observableArray([]),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            exportInProgress: ko.observable(false),
            exportTextBox: ko.observable("Export to CSV"),
            onClickExportToCSV: function () {
                self.onClickExportToCSV();
            },
        };
    }

    public buildDatePickerCalendar(){
        this.dateFilter.buildCalendar();
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.viewModel.list.orderBy,
            orderByDirection: this.viewModel.list.orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                keyword: this.getTemplateViewModel().filter.filterKeyword,
            },
        };
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            data.orderByDirection(data.orderByDirection() == "DESC" ? "ASC" : "DESC");
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    public onClickExportToCSV(): void {
        this.getTemplateViewModel().exportInProgress(true);
        this.getTemplateViewModel().exportTextBox("Exporting...");

        const filters = this.getViewModelForRequest().filters;
        this.caller.exportToCSV(filters);
    }

    public setPriceHistory(records: Array<CarPriceHistory>): void{
        this.getTemplateViewModel().priceHistory(records);
    }

    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setViewModelFromRequest(urlParams){

        if(urlParams != null){
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if(urlParams.startDateRange || urlParams.endDateRange){
                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }
            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            let keywordString = urlParams.keyword;
            if(urlParams.keyword){
                keywordString = urlParams.keyword.replaceAll("+", " ");
            }
            this.filter.getTemplateViewModel().filterKeyword(keywordString);
        }
    }

    private setDefaultDateRange(): void {
        let now = new Date();
        this.dateFilter.setDateRange(
            new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30, 0, 0, 0),
            new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59),
        );
    }

    private setDateFilters(startDate, endDate): void {
        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/car_price_report_template.ts